<!--
	ServiceUpdateFields.svelte

    This component displays the many fields of a Service.
    Set up as two blocks L/R which will stack in mobile views.
-->

<script>
    import { onMount } from 'svelte';
    import { formatNullFieldsToEmptyStrings } from '../../common/utils.js';

    // TCARE components
    import TaxonomyFieldsGroup from '../field-groups/TaxonomyFieldsGroup.svelte';
    import ServiceFieldsGroup1 from '../field-groups/ServiceFieldsGroup1.svelte';
    import ServiceFieldsGroup2 from '../field-groups/ServiceFieldsGroup2.svelte';
    import ServiceFieldsGroup3 from '../field-groups/ServiceFieldsGroup3.svelte';
    import ServiceFieldsGroup4 from '../field-groups/ServiceFieldsGroup4.svelte';
    import ServiceFieldsGroup6Stats from '../field-groups/ServiceFieldsGroup6Stats.svelte';
    import ServiceFieldsGroup5Coverage from '../field-groups/ServiceFieldsGroup5Coverage.svelte';

    // SMUI components

    export let store;                 // masterUpdateService object passed in from <ServiceUpdatePage>

    $: apiData = $store.apiData;
    $: leftServiceData = apiData.leftService;           // IMPORTANT - must use the apiData!
    $: rightServiceData = apiData.rightService;         // IMPORTANT - must use the apiData!


    const CHANGED_STYLE = 'color: white; background-color: green';
    const UNCHANGED_STYLE = '';
    
    onMount(() => {
        // console.log('');
        // console.log('ServiceUpdateFields onMount');
        // console.log('$store:');
        // console.log($store);
    })

    // const resetAllValues = () => {
    //     rightServiceData = JSON.parse(JSON.stringify(rightServiceData));
    //     $store = $store;              // refresh the UI for the field
    // }


</script>


<style>
    /* already using tcare-form CSS */

	* :global(.label svg) {
		width: 20px !important;
		height: 20px !important;
		fill: var(--tcare-primary);
		outline: none;
	}

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>



{#if apiData}
    <div class="service-details-update-fields tcare-form">
        <div class="spacer-h-25"></div>

        <TaxonomyFieldsGroup
            store={store}
            leftService={null}
            rightService={null}
            onCopyTaxonomy={null}
            isEditable={true}
            isOpen={true}
            showTcareTax1={true}
            showDiffs={true}
        />
                
        <ServiceFieldsGroup1
            bind:store={store}
            leftService={leftServiceData}
            rightService={rightServiceData}
            onCopyValue={null}
            isEditable={true}
            isOpen={true}
            showDiffs={true}
        />
        
        <ServiceFieldsGroup2
            bind:store={store}
            leftService={null}
            rightService={null}
            onCopyValue={null}
            isEditable={true}
            isOpen={true}
            showDiffs={true}
        />

        <ServiceFieldsGroup3
            bind:store={store}
            leftService={null}
            rightService={null}
            onCopyValue={null}
            isEditable={true}
            isOpen={true}
            showDiffs={true}
        />

        <ServiceFieldsGroup4
            bind:store={store}
            leftService={null}
            rightService={null}
            onCopyValue={null}
            isEditable={true}
            isOpen={true}
            showDiffs={true}
        />

        <!--
        <ServiceFieldsGroup5Coverage
            bind:store={store}
            leftService={null}
            rightService={null}
            onCopyValue={null}
            isEditable={true}
            isOpen={true}
            showDiffs={true}
        />

        <ServiceFieldsGroup6Stats
            bind:store={store}
            leftService={null}
            rightService={null}
            onCopyValue={null}
            isEditable={true}
            isOpen={false}
            showDiffs={true}
        />
        -->

        <div class="spacer-h-25"></div>

    </div>
{/if}
